// ms * seconds * minutes * hours * days = miliseconds for 365 days
const cookieTime = 1000 * 60 * 60 * 24 * 365;

function getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

function consentModalAccepted() {
    let date = new Date();
    date.setTime(date.getTime() + cookieTime);
    document.cookie = "AnalyticsCookies=Accepted; expires=" + date.toGMTString() + ";path=/;";
}

function consentModalDeclined() {
    let date = new Date();
    date.setTime(date.getTime() + cookieTime);
    document.cookie = "AnalyticsCookies=Declined; expires=" + date.toGMTString() + ";path=/;";
}

function setConsent(consent) {
    const consentMode = {
        'ad_storage': consent.marketing ? 'granted' : 'denied',
        'ad_user_data': consent.marketing ? 'granted' : 'denied',
        'ad_personalization': consent.marketing ? 'granted' : 'denied',
        'analytics_storage': consent.marketing ? 'granted' : 'denied',
        'functionality_storage': consent.necessary ? 'granted' : 'denied',
        'personalization_storage': consent.preferences ? 'granted' : 'denied',
        'security_storage': consent.necessary ? 'granted' : 'denied',
    };

    gtag('consent', 'update', consentMode);
    localStorage.setItem('consentMode', JSON.stringify(consentMode));
}

$(document).ready(function () {

    if($('#consent-modal').length > 0) {
        if(getCookieValue('AnalyticsCookies') == 'NotSelected' || getCookieValue('AnalyticsCookies') == '') {
            $('#consent-modal').modal('toggle');
        }
    
        // Accept all
        $(document).on('click', '.btn-consent-accecpt-all', function(){
            
            // visual check all switches.
            $('#toggle-content-necessary').attr('checked', true).prop('checked', true);
            $('#toggle-content-preferences').attr('checked', true).prop('checked', true);
            $('#toggle-content-statistics').attr('checked', true).prop('checked', true);
            $('#toggle-content-marketing').attr('checked', true).prop('checked', true);
            $('#toggle-content-unclassified').attr('checked', true).prop('checked', true);

            setTimeout(() => {
                consentModalAccepted();
                if((config.vendor.google.analytics != '' || config.vendor.google.gtag != '')) {
                    setConsent({
                        necessary: true,
                        preferences: true,
                        statistics: true,
                        marketing: true,
                        unclassified: true,
                    });
                }
                $('#consent-modal').modal('hide');
            }, 400);

        });
    
        // Deny all.
        $(document).on('click', '.btn-consent-deny', function(){  
            consentModalDeclined();
            if((config.vendor.google.analytics != '' || config.vendor.google.gtag != '')) {
                setConsent({
                    necessary: false,
                    preferences: false,
                    statistics: false,
                    marketing: false,
                    unclassified: false,
                });
            }
            $('#consent-modal').modal('hide');
        });

        // Accept selection.
        $(document).on('click', '.btn-consent-accept-selection', function(){
            consentModalAccepted();
            if(config.vendor.google.analytics != '' || config.vendor.google.gtag != '') {
                setConsent({
                    necessary: true,
                    preferences: $('#toggle-content-preferences').is(':checked'),
                    statistics: $('#toggle-content-statistics').is(':checked'),
                    marketing: $('#toggle-content-marketing').is(':checked'),
                    unclassified: $('#toggle-content-unclassified').is(':checked'),
                });
            }
            $('#consent-modal').modal('hide');
        });

        // Go to details tab and toggle consent modify & selection button.
        $(document).on('click', '.btn-consent-modify, #details-tab', function(){
            $('.btn-consent-modify').hide();
            $('.btn-consent-accept-selection').show();

            $('#details-tab').tab('show')
        });

        // Toggle content modify & selection button 
        $(document).on('click', '#consent-tab, #about-tab', function(){
            $('.btn-consent-modify').show();
            $('.btn-consent-accept-selection').hide();
        });

        // Open / close consent modal.
        $(document).on('click', '.btn-consent-toggle', function(){
            $('#consent-modal').modal('toggle');
        });


        // Consent switches handlers.
        $(document).on('click', '#toggle-content-necessary', function(){
            let date = new Date();
            date.setTime(date.getTime() + cookieTime);
            if($(this).is(':checked')) {
                document.cookie = "content-necessary=Accepted; expires=" + date.toGMTString() + ";path=/;";
            } else {    
                document.cookie = "content-necessary=Declined; expires=" + date.toGMTString() + ";path=/;";
            }
        });

        $(document).on('click', '#toggle-content-preferences', function(){
            let date = new Date();
            date.setTime(date.getTime() + cookieTime);
            if($(this).is(':checked')) {
                document.cookie = "content-preferences=Accepted; expires=" + date.toGMTString() + ";path=/;";
            } else {    
                document.cookie = "content-preferences=Declined; expires=" + date.toGMTString() + ";path=/;";
            }
        });

        $(document).on('click', '#toggle-content-statistics', function(){
            let date = new Date();
            date.setTime(date.getTime() + cookieTime);
            if($(this).is(':checked')) {
                document.cookie = "content-statistics=Accepted; expires=" + date.toGMTString() + ";path=/;";
            } else {    
                document.cookie = "content-statistics=Declined; expires=" + date.toGMTString() + ";path=/;";
            }
        });

        $(document).on('click', '#toggle-content-marketing', function(){
            let date = new Date();
            date.setTime(date.getTime() + cookieTime);
            if($(this).is(':checked')) {
                document.cookie = "content-marketing=Accepted; expires=" + date.toGMTString() + ";path=/;";
            } else {    
                document.cookie = "content-marketing=Declined; expires=" + date.toGMTString() + ";path=/;";
            }
        });

        $(document).on('click', '#toggle-content-unclassified', function(){
            let date = new Date();
            date.setTime(date.getTime() + cookieTime);
            if($(this).is(':checked')) {
                document.cookie = "content-unclassified=Accepted; expires=" + date.toGMTString() + ";path=/;";
            } else {    
                document.cookie = "content-unclassified=Declined; expires=" + date.toGMTString() + ";path=/;";
            }
        });
    }
});